import { render, staticRenderFns } from "./IdVerify.vue?vue&type=template&id=0a49b5b7&scoped=true&"
import script from "./IdVerify.vue?vue&type=script&lang=js&"
export * from "./IdVerify.vue?vue&type=script&lang=js&"
import style0 from "./IdVerify.vue?vue&type=style&index=0&id=0a49b5b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49b5b7",
  null
  
)

export default component.exports